import { IKeyedInDirection } from "./IKeyedInDirection";
import { ND } from '../../utilities/Constants';

export interface IKeyedInPartition {
    isEdit: boolean;
    index: number;
    name: string;
    directions: IKeyedInDirection[];
}

export class KeyedInPartition implements IKeyedInPartition {
    index: number;
    name: string;

    constructor(index: number, name: string, directions: IKeyedInDirection[]) {
        this.index = index;
        this.name = name;
        this.isEdit = false;
        const d = directions;
        d.forEach(x => x.name === ND ? x.name = "--" : x.name = x.name)
        this.directions = d;
        this.name = this.name === "" ? "Position " + (this.index + 1) : this.name;
    }
    directions: IKeyedInDirection[];
    isEdit: boolean;
}